class Header extends React.Component {

    componentDidMount() {
        $('#app').on('scroll', this.onScroll);
        $(window).resize(this.onScroll);

        $('a').click(this.smoothScroll);
    }

    smoothScroll(e) {
        if ($(e.target).hasClass('smoothscroll')) {
            e.preventDefault();

            if (!$(e.target.hash).length)
                return;

            $('#app').animate({
                scrollTop : $(e.target.hash).position().top + $('#app').scrollTop()
            }, 700);


            $('.mobile-nav').css({
                'top' : '-440px',
            });
        }
    }

    componentWillUnmount() {
        $('#app').off('scroll', this.onScroll);
        $(window).off('resize', this.onScroll);
    }

    onScroll() {
        if ($('#app').scrollTop() > 0 && !$('#header').hasClass('header__opaque'))
            $('#header').addClass('header__opaque');
        else if ($('#app').scrollTop() === 0 && $('#header').hasClass('header__opaque'))
            $('#header').removeClass('header__opaque');
    }

    toggleMobileNav() {
        if ($('.mobile-nav').offset().top === 66) {
            $('.mobile-nav').css({
                'top' : '-440px',
            });
        } else {
            $('.mobile-nav').css({
                'top' : '66px',
            });
        }
    }

    render() {
        return (
            <header
                className='header'
                id='header'>

                <div className='header__content row'>

                    <div className='header__logo'>
                        <a href='index.html'></a>
                    </div>

                    <nav className='header__nav'>

                        <ul>
                            <li id='nav-hero' className='header__nav--current'><a className='smoothscroll' href='#hero'>Home.</a></li>
                            <li id='nav-portfolio'><a className='smoothscroll' href='#portfolio'>Works.</a></li>
                            <li id='nav-services'><a className='smoothscroll' href='#services'>Services.</a></li>
                            <li id='nav-about'><a className='smoothscroll' href='#about'>About.</a></li>
                            <li id='nav-team'><a className='smoothscroll' href='#team'>Team.</a></li>
                            <li id='nav-contact'><a className='smoothscroll' href='#contact'>Contact</a></li>
                        </ul>

                    </nav>

                    <ul className='header__social'>
                        <li><a href='https://www.facebook.com/Codi-Studios-143381665733601/' target='_blank'><i className='fa fa-facebook'></i></a></li>
                        <li><a href='https://twitter.com/CodiStudios' target='_blank'><i className='fa fa-twitter'></i></a></li>
                    </ul>

                </div>

                <div className='header__mobile' onClick={this.toggleMobileNav}>
                    <i className="fa fa-bars" aria-hidden="true" />
                </div>

            </header>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./ui_src/app/components/header/Header.react.jsx